import { ReasonType } from '@tiendanube/common';
import { Label } from '@tiendanube/components';
import { ArrowsHorizontalIcon } from '@tiendanube/icons';

type AppearanceType = 'success' | 'danger' | 'primary';
type VariationAppearanceSymbolType = '+' | '-' | '=' | '∞';
interface StockMovementProps {
  id: string;
  variation: number | '∞';
  variationSymbol: VariationAppearanceSymbolType | '';
  reason: ReasonType;
}

const appearance: Record<VariationAppearanceSymbolType, AppearanceType> = {
  '+': 'success',
  '-': 'danger',
  '∞': 'primary',
  '=': 'primary',
};

function StockMovement({
  id,
  variation,
  variationSymbol,
  reason,
}: StockMovementProps): JSX.Element {
  if (reason === 'stockTransferIn' || reason === 'stockTransferOut') {
    return (
      <StockTransferMovement
        id={id}
        variation={variation}
        variationSymbol={variationSymbol}
      />
    );
  }

  const symbol = variation === '∞' ? '∞' : variationSymbol;
  const label = `${
    variationSymbol !== '=' ? variationSymbol : ''
  } ${variation}`;
  const icon = variationSymbol === '=' ? { icon: ArrowsHorizontalIcon } : {};
  const appearanceVariation = variation === 0 ? 'danger' : appearance[symbol];

  return (
    <Label id={id} {...icon} appearance={appearanceVariation} label={label} />
  );
}

function StockTransferMovement({
  id,
  variation,
  variationSymbol,
}: Readonly<Omit<StockMovementProps, 'reason'>>): JSX.Element {
  const symbol = ['+', '-'].includes(variationSymbol) ? variationSymbol : '';
  const value = ['∞', 0].includes(variation) ? '' : variation;
  const label = `${symbol} ${value}`;
  return (
    <Label
      id={id}
      icon={ArrowsHorizontalIcon}
      appearance="primary"
      label={label}
    />
  );
}

export default StockMovement;
